// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Container, useTheme } from '@mui/material';

// hooks
import useResponsive from '../../hooks/useResponsive';

// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';

// sections
import { LoginForm } from '../../sections/auth/login';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  overflow: 'hidden',
  background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
  [theme.breakpoints.down('md')]: {
    background: 'linear-gradient(180deg, #1a237e 0%, #0d47a1 100%)',
  },
}));

const ContentStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  margin: 'auto',
  marginTop: theme.spacing(8), // Default margin top
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: 'rgba(255, 255, 255, 0.98)',
  borderRadius: 16,
  backdropFilter: 'blur(10px)',
  boxShadow: '0 12px 40px 0 rgba(31, 38, 135, 0.37)',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(8),
    borderRadius: 20,
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '95%',
    margin: theme.spacing(2),
    marginTop: theme.spacing(12), // Increased margin top for mobile
    borderRadius: 16,
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3, 0),
  background: 'linear-gradient(to right, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
}));

const DivLogoSvg = styled('div')(({ theme }) => ({
  width: '160px', // Adjusted size for better proportion
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '140px',
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 6), // Adjusted padding for better spacing
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));

// ----------------------------------------------------------------------

export default function Login() {
  const theme = useTheme();

  return (
    <Page title="Login">
      <RootStyle>
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            alignItems: 'flex-start', // Changed from center to flex-start
            justifyContent: 'center',
            minHeight: '100vh',
            pt: { xs: 5, md: 8 }, // Adjusted padding top
            px: { xs: 2, sm: 3 }
          }}
        >
          <ContentStyle>
            <LogoContainer>
              <DivLogoSvg>
                <Logo sx={{ width: '100%', height: '100%' }} loginPage />
              </DivLogoSvg>
            </LogoContainer>

            <FormContainer>
              <LoginForm />
            </FormContainer>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
